
import { Box, Button, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../../../Components/Table/CustomTable'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import actions from '../../../ReduxStore/actions';
import { Formik, Form } from 'formik';
import CustomUploadComponent from '../../../Components/CustomExcelUpload/CustomExcelUpload';
import { toast } from 'react-toastify';
import { adminUrl } from '../../../constants';
import InvalidRowsModal from '../../../Components/InvalidRowsModal/InvalidRowsModal';
import ExcelJS from 'exceljs';
// import { saveAs } from 'file-saver';
import logo from "../../../Assets/logo.png"
import FullPageLoader from '../../../Components/FullPageLoader/FullPageLoader';


const OverviewReports = ({ dynamicLogo }) => {

    const tableHeadData = [
        "S.No", "Employee ID", "Name", "Designation", "Department", "Sub Department", "Manager", "Reviewer", "Employee Rating", "Employee PMS Score", "Manager Rating", "Manager PMS Score", "Reviewer Rating", "Reviewer PMS Score", "PMS Status"

    ]
    const tableData = [
        { employeeId: "2", name: "RAMA M", designation: "ASSEMBLY SUPERVISOR", department: "OPERATIONS", subdepartment: "ASSEMBLY", manager: "DINAKARAN S", reviewer: "MUTHIAH K", employeeRating: "OUTSTANDING(O)", employeemsScore: "100", managerRating: "OUTSTANDING(O)", managerPmsScore: "100", reviewerRating: "OUTSTANDING(O)", reviewerPmsScore: "100", pmsStatus: "PMS Completed" },
        { employeeId: "3", name: "RAMA M", designation: "ASSEMBLY SUPERVISOR", department: "OPERATIONS", subdepartment: "ASSEMBLY", manager: "DINAKARAN S", reviewer: "MUTHIAH K", employeeRating: "OUTSTANDING(O)", employeemsScore: "100", managerRating: "OUTSTANDING(O)", managerPmsScore: "100", reviewerRating: "OUTSTANDING(O)", reviewerPmsScore: "100", pmsStatus: "PMS Completed" },
        { employeeId: "456", name: "RAMA M", designation: "ASSEMBLY SUPERVISOR", department: "OPERATIONS", subdepartment: "ASSEMBLY", manager: "DINAKARAN S", reviewer: "MUTHIAH K", employeeRating: "OUTSTANDING(O)", employeemsScore: "100", managerRating: "OUTSTANDING(O)", managerPmsScore: "100", reviewerRating: "OUTSTANDING(O)", reviewerPmsScore: "100", pmsStatus: "PMS Completed" },
        { employeeId: "265", name: "RAMA M", designation: "ASSEMBLY SUPERVISOR", department: "OPERATIONS", subdepartment: "ASSEMBLY", manager: "DINAKARAN S", reviewer: "MUTHIAH K", employeeRating: "OUTSTANDING(O)", employeemsScore: "100", managerRating: "OUTSTANDING(O)", managerPmsScore: "100", reviewerRating: "OUTSTANDING(O)", reviewerPmsScore: "100", pmsStatus: "PMS Completed" },
        { employeeId: "265", name: "RAMA M", designation: "ASSEMBLY SUPERVISOR", department: "OPERATIONS", subdepartment: "ASSEMBLY", manager: "DINAKARAN S", reviewer: "MUTHIAH K", employeeRating: "OUTSTANDING(O)", employeemsScore: "100", managerRating: "OUTSTANDING(O)", managerPmsScore: "100", reviewerRating: "OUTSTANDING(O)", reviewerPmsScore: "100", pmsStatus: "PMS Completed" },




    ]


    const [invalidRowsModalopen, setInvalidRowsModalOpen] = useState(false);
    const [invalidRwModalResponseData, setInvalidRwModalResponseData] = useState([]);

    const handleInvalidRowsModalOpen = () => {
        setInvalidRowsModalOpen(true)
    }
    const handleInvalidRowsModalClose = () => {
        setInvalidRowsModalOpen(false)
    }



    const handleDownloadExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Overview Reports');
        const year = new Date().getFullYear();

        // 1. Add Logo
        const response = await fetch(dynamicLogo);
        const imageBlob = await response.blob();
        const imageBuffer = await imageBlob.arrayBuffer();
        const imageId = workbook.addImage({
            buffer: imageBuffer,
            extension: 'png',
        });
        worksheet.addImage(imageId, {
            tl: { col: 1, row: 1 },
            ext: { width: 160, height: 60 },
        });

        // 2. Title: Merge cells for centering
        worksheet.mergeCells('C3:E2');
        worksheet.getCell('C3').value = 'Company Performance Overview Report';
        worksheet.getCell('C3').font = { size: 16, bold: true };
        worksheet.getCell('C3').alignment = { vertical: 'middle', horizontal: 'center' };

        // 3. Year
        worksheet.getCell('D4').value = `Year: ${year}`;
        worksheet.getCell('D4').font = { italic: true, size: 12 };
        worksheet.getCell('D4').alignment = { vertical: 'middle', horizontal: 'left' };

        // 4. Spacer rows
        worksheet.addRow([]);
        worksheet.addRow([]);
        // worksheet.addRow([]);
        // worksheet.addRow([]);
        // 4. Minimal Spacer Row (optional)
        // worksheet.addRow([]);
        // worksheet.addRow([]);


        // 5. Column Headers
        const headers = [
            "S.No", "Employee ID", "Name", "Designation", "Department", "Sub Department",
            "Manager", "Reviewer", "Employee Rating", "Employee PMS Score",
            "Manager Rating", "Manager PMS Score", "Reviewer Rating", "Reviewer PMS Score", "PMS Status"
        ];

        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.alignment = { vertical: 'middle', horizontal: 'center' };

        // 6. Data Rows
        rowTableData.forEach((row, index) => {
            worksheet.addRow([
                index + 1,
                row.employee_code || "N/A",
                row.employee_name || "N/A",
                row.designation_name || "N/A",
                row.department_name || "N/A",
                row.sub_department_name || "N/A",
                row.reporting_manager_name || "N/A",
                row.reviewer_name || "N/A",
                row.employee_rating || "N/A",
                row.employee_pms_score ?? "N/A",
                row.manager_rating ?? "N/A",
                row.manager_pms_score ?? "N/A",
                row.reviewer_rating ?? "N/A",
                row.reviewer_pms_score ?? "N/A",
                row.appraisal_current_status || "N/A",
            ]);
        });

        // 7. Set Column Widths
        worksheet.columns = headers.map(() => ({ width: 20 }));

        // 8. Background Fill for Top Rows
        for (let rowNum = 1; rowNum <= 5; rowNum++) {
            for (let col = 1; col <= headers.length; col++) {
                worksheet.getCell(rowNum, col).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'e0e0e0' }, // White background
                };
            }
        }

        // 9. Save Excel File
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Overview_Reports.xlsx');
    };




    const navigate = useNavigate()
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(setHeaderName("Reports"));
        dispatch(setSubHeaderName("Oveview Reports"));
    }, [dispatch]);


    const { getAdminReportByAppraisalYear } = useSelector((state) => state?.getAdminReportByAppraisalYear);


    const handleaGetDataYearById = async (id) => {

        const data1 = {
            data: {
                appraisal_year_id: id
            },
            method: "post",
            apiName: `getAdminReportByAppraisalYear`
        };
        const responseData = dispatch(actions.GETADMINREPORTSBYAPPRAISALYEAR(data1));
        console.log(responseData, "responseData")


    }

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")




    useEffect(() => {
        const tempArr = [];
        const reportData = getAdminReportByAppraisalYear?.data;

        console.log(reportData, "mpDta");

        reportData?.forEach((data, index) => {
            tempArr.push({
                // id: index + 1, // For S.No
                employee_code: data?.employee_code || "N/A",
                employee_name: data?.employee_name || "N/A",
                designation_name: data?.designation_name || "N/A",
                department_name: data?.department_name || "N/A",
                sub_department_name: data?.sub_department_name || "N/A",
                reporting_manager_name: data?.reporting_manager_name || "N/A",
                reviewer_name: data?.reviewer_name || "N/A",
                employee_rating: data?.employee_rating || "N/A",
                employee_pms_score: data?.employee_pms_score || "N/A",
                manager_rating: data?.manager_rating || "N/A",
                manager_pms_score: data?.manager_pms_score || "N/A",
                reviewer_rating: data?.reviewer_rating || "N/A",
                reviewer_pms_score: data?.reviewer_pms_score || "N/A",
                appraisal_current_status: [data?.appraisal_current_status || "--", data?.reviewer_reject_comment || "--"],
            });
        });

        setRowTableData(tempArr);
    }, [getAdminReportByAppraisalYear]);


    const [loading, setLoading] = useState(false)
    const handleSubmit = async (values, { resetForm }) => {
        console.log(values, "valuesssssss")
        setLoading(true)
        if (values?.file) {
            const formData = new FormData();
            formData.append("file", values?.file);
            console.log(formData, "formData")
            const data1 = {
                data: formData,
                method: "post",
                apiName: "bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel"
            };
            const responseData = await dispatch(actions.BULKUPDATEKRAKPIANSWERSOFMANAGERANDREVIEWEREVALUTATIONFROMEXCEL(data1));
            console.log(responseData, "responseData")
            if (responseData?.payload?.message === "Bulk update successful.") {
                setLoading(false)
                toast.success("Bulk upload successful.")
                setInvalidRwModalResponseData(responseData?.payload?.data)
                handleInvalidRowsModalOpen(true)
                resetForm()
            } else {
                setLoading(false)
                toast.error(responseData?.payload?.message)
            }

        }
    }
    // const handleSamplDownload = () => {
    //     window.open(`${adminUrl}downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile`);
    // }
    const authToken = localStorage.getItem("authToken")
    const handleSamplDownload = async () => {
        try {
            const response = await fetch(`${adminUrl}downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${authToken}`, // Replace with actual token
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Score_update_Sample.xlsx'; // Set desired filename
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };

    return (
        <div>
            {loading && <FullPageLoader />}
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    mb: 2
                }}
            >
                <Box
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                    <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px" }}>
                        Upload Excel For Manager and Reviewer PMS Score
                    </Typography>
                    {/* <Typography
                        variant='body1'
                        onClick={() => {
                            setShowExcelUpload(!showExcelUpload)
                            setEditData()
                        }}
                        sx={{
                            textAlign: "end",
                            color: 'var(--main-color)',
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer"
                        }}
                    >
                        {showExcelUpload ? <IoIosArrowRoundBack style={{ mr: 1, fontSize: "25px" }} /> : <Upload sx={{ mr: 1 }} />}
                        {showExcelUpload ? 'Back to Form' : 'Upload Excel'}
                    </Typography> */}
                </Box>

                <Formik
                    enableReinitialize
                    initialValues={{
                        // departments: editData?.department_name || '',
                        file: null
                    }}
                    // validationSchema={validationSchema}

                    onSubmit={
                        handleSubmit
                    }
                >
                    {({ errors, touched, handleChange, values, setFieldValue, resetForm, isSubmitting }) => (
                        <Form>
                            <Grid container spacing={2} mt={2}>
                                <Grid item size={{ xs: 12, md: 6 }}>
                                    <>
                                        <CustomUploadComponent
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            resetForm={resetForm}
                                        />
                                        {/* <Typography variant='body1'
                                                           sx={{
                                                               // borderBottom: "1px solid var(--main-color)",
                                                               cursor: "pointer",
                                                               color: "var(--main-color)"
                                                           }}
                                                       >Download & Sample Excel Format</Typography> */}
                                        {/* <a href="/sample.xlsx" download style={{ textDecoration: 'none' }}> */}
                                        <Typography
                                            onClick={handleSamplDownload}
                                            variant="body1"
                                            sx={{
                                                cursor: "pointer",
                                                color: "var(--main-color)"
                                            }}
                                        >
                                            Download & Sample Excel Format
                                        </Typography>
                                        {/* </a> */}

                                    </>

                                </Grid>

                                {/* {!showExcelUpload && ( */}
                                <Grid item size={{ xs: 12 }} sx={{ mt: 3 }}>
                                    <Button
                                        type="submit"
                                        variant='contained'
                                        disabled={isSubmitting}
                                        sx={{
                                            background: "var(--main-color)",
                                            textTransform: "none"
                                        }}
                                    >
                                        Submit
                                        {/* {editData?.department_id ? "Update" : "Submit"} */}
                                    </Button>
                                </Grid>
                                {/* )} */}
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    // mt: 6,
                    // maxWidth: "950px"
                }}
            >
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12 }} sx={{ width: "100px", flex: 1 }}>
                        <CustomTable
                            tableHeadData={tableHeadData}
                            tableData={rowTableData}
                            title="Overview Reports List"
                            // tableEdit={true}
                            // tableActions={true}
                            tableSearch={true}
                            handleDownloadExcel={handleDownloadExcel}
                            tableExcelDownload={true}
                            handleaGetDataYearById={handleaGetDataYearById}

                            // tableReportSearch={true}
                            OverviewReportsFilter={true}
                            tableReportSearch={true}
                        // tableActivate={true}

                        />

                    </Grid>
                </Grid>


            </Box>
            <InvalidRowsModal name="updateManagerReviewer" open={invalidRowsModalopen} onClose={handleInvalidRowsModalClose} data={invalidRwModalResponseData} />

        </div>
    )
}

export default OverviewReports